module.exports = __webpack_public_path__ + "img/PDF.6a1c20b5.svg";